import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { InspirationalTemplatesGrid } from '../../InspirationalTemplatesGrid/InspirationalTemplatesGrid';
import s from './InspirationalTemplatesPage.scss';
import { TemplatesPageHeading } from '../TemplatesPageHeading/TemplatesPageHeading';

interface InspirationalTemplatesPageProps {
  heading: string;
}

export const InspirationalTemplatesPage: FC<
  InspirationalTemplatesPageProps
> = ({ heading }) => {
  const { t } = useTranslation();

  return (
    <>
      <header className={s.header}>
        <TemplatesPageHeading
          heading={heading}
          subHeading={t('app.templates.inspirational.subtitle')}
        />
      </header>
      <InspirationalTemplatesGrid />
    </>
  );
};
